// API base URL — override with REACT_APP_API_URL env var for production
const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8001';
export default API_BASE;

// Real-time (Socket.IO) collaboration service — separate process/port.
export const REALTIME_BASE = process.env.REACT_APP_REALTIME_URL || 'http://localhost:8002';
